
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SupersedableProductPlanDtoModel } from 'models/generated/GormGateway.Models.SupersedableProductPlanDto';


const _gormGateway_ProductPlanControllerHelper = new Map<string, Object>();
_gormGateway_ProductPlanControllerHelper.set('GetSupersedableProductPlans', SupersedableProductPlanDtoModel);


export const gormGateway_ProductPlanControllerHelper = _gormGateway_ProductPlanControllerHelper;

